window.EducationForm = function(scope, userId, googleMaps, isDateOptional) {
    var self = this;
    var formName = "education-form";
    self.name = formName;
    self.status =  {loading: true, completed: false};
    var _protected = BaseForm.call(self, formName, scope);

    var educationToDelete = [];
    self.data.education = [];
    self.isDateOptional = isDateOptional;

    self.degrees = [
        {"degree": $filter("translate")("Secondary"), "id": 1},
        {"degree": $filter("translate")("Trade/Apprenticeship"), "id": 2},
        {"degree": $filter("translate")("Non University Certificate/Diploma"), "id": 3},
        {"degree": $filter("translate")("Associates degree"), "id": 6},
        {"degree": $filter("translate")("Bachelor's Degree"), "id": 4},
        {"degree": $filter("translate")("Professional"), "id": 7},
        {"degree": $filter("translate")("Master's Degree"), "id": 5},
        {"degree": $filter("translate")("Doctoral"), "id": 8},
        {"degree": $filter("translate")("High School"), "id": 9},
        {"degree": $filter("translate")("GED Equivalent"), "id": 10}
    ];

    self.load = async () => {
        if (!userId) {
            if (self.type === 'job_application') {
                self.data.education.push({});
            }
            return;
        }

        try {
            const data = await SettingsAPI.loadUserEducation(userId);

            data.forEach(education => {
                education.Institution = {
                    label: education.Institution.name,
                    value: education.Institution
                };

                education.still_in_school = !!(education.start_date && !education.end_date);
            });

            self.data.education = data;
            self.calculateCompletness();

            if (self.type === 'job_application' && data.length === 0) {
                self.data.education.push({});
            }

            self.status.loading = false;
            scope.$digest();
        } catch (error) {
            console.error('Error loading user education:', error);
        }
    };

    self.setIsEducationDatesMandatoryFlag = (isEducationDatesMandatory) => {
        self.isEducationDatesMandatory = isEducationDatesMandatory;
    }

    self.save = function() {
        var defer = $q.defer();

        SettingsAPI.saveUserEducation(googleMaps, userId, self.data.education, educationToDelete, self.type)
            .then(
            function(res) {
                educationToDelete = [];
                defer.resolve(res);
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.validator.afterValidation(function () {
        setTimeout(function(){
            self.calculateCompletness();
        }, 150);
    });

    self.deleteEducation = function(index) {

        self.validator.clearValidate(index);

        if (self.data.education[index] && self.data.education[index].id) {
            educationToDelete.push(self.data.education[index]);
        }

        self.data.education.splice(index, 1);
        self.calculateCompletness();
    };

    self.addNewEducation = function() {
        self.data.education.push({});
        self.calculateCompletness();
    };

    self.calculateCompletness = function () {

        var checkInterval;

        checkInterval = setInterval(function() {
            if ($("form." + formName + " [validate-rule]").length) {
                self.status.completed = self.validator.validateWithoutError();
                self.status.loading = false;

                if (scope) {
                    try {
                        scope.$digest();
                    }
                    catch (e) { /* Do Nothing */ }
                }
                else {
                    console.warn("Scope is not here: form name: ", name);
                }

                clearInterval(checkInterval);
            }
        }, 500);
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var fieldIndex = optionsField.attr('validate-index');

        switch (rule.name) {
            case 'date_range':
                if (self.data.education[fieldIndex].start_date && self.data.education[fieldIndex].end_date) {
                    var start_date = new Date(self.data.education[fieldIndex].start_date);
                    var end_date = new Date(self.data.education[fieldIndex].end_date);

                    if (start_date.getTime() >= end_date.getTime() && !self.data.education[fieldIndex]["still_in_school"]) {
                        return false;
                    }
                }

                return true;
                break;

            case 'required_if_start':
                var dependency = rule.params[0];
                if (!self.validator.getFieldValue(field) && !self.data.education[fieldIndex][dependency]) {
                    return false;
                }
                return true;
                break;

            case 'required_if':

                var dependency = rule.params[0];

                if (!self.validator.getFieldValue(field) &&
                    (self.data.education[fieldIndex][dependency] || self.data.education[fieldIndex]["still_in_school"])) {
                    return false;
                }

                break;
        }

        return true;
    };

	self.parseEducation = function (educations) {
		var educations_array = [];
		for (var i in educations) {
			if (!_.isEmpty(educations[i])) {
				var education = {
					DegreeLookup: {},
					DisciplineLookup: {
						name: Utils.capitalize(educations[i].area_of_study) || ''
					},
					start_date: educations[i].start_date,
					Institution: {
						label: Utils.capitalize(educations[i].institue_name) || ''
					}
				};
				if (educations[i].end_date && moment().diff(educations[i].end_date, 'days') > -1) {
					education.end_date = educations[i].end_date;
				}
				if (educations[i].degree) {
					education.DegreeLookup.degree = Utils.capitalize(educations[i].degree.degree);
					education.DegreeLookup.id = educations[i].degree.id;
				}
				education.has_value = true;
                education.still_in_school = educations[i].present_education;
				educations_array.push(education);
			}
		}
		
		if (educations_array.length) {
			self.data.education = educations_array;
		}
	};
};
